import React from 'react';
import './Maintenance.scss';

const Maintenance = () => {
  return (
    <div className="maintenance-container">
      <div className="maintenance-content">
        <div className="logo-container">
          <img className="maintenance-logo" src={process.env.PUBLIC_URL + '/logos/eeLogo.png'} alt="AuthorEase Logo" />
        </div>
        <h1>Site Under Maintenance</h1>
        <div className="maintenance-icon">
          <i className="fas fa-wrench"></i>
        </div>
        <p>We are currently performing scheduled maintenance on our site.</p>
        <p>Please check back later. We apologize for any inconvenience.</p>
      </div>
    </div>
  );
};

export default Maintenance; 